import { render, staticRenderFns } from "./view.admin.vue?vue&type=template&id=81e3ff3a&"
import script from "./view.admin.vue?vue&type=script&lang=ts&"
export * from "./view.admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports